import { render, staticRenderFns } from "./ShippingSectionComponent.vue?vue&type=template&id=70b4b6d3&lang=pug&"
import script from "./ShippingSectionComponent.vue?vue&type=script&lang=js&"
export * from "./ShippingSectionComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports